<template>
  <!-- <template #title>
      <template v-if="item.form_id">
        <br />
        <span> "{{ FormsTypes?.[item.form_id] }}" </span>
      </template>
    </template> -->
  <a-tooltip placement="right">
    <template #title v-if="isLinkFormButtonDisabled">
      Un formulario ya se encuentra vinculado en un nivel superior o inferior.
    </template>

    <a-button
      type="text"
      :disabled="isLinkFormButtonDisabled"
      :class="item.status === 2 ? 'button-disabled' : ''"
      @click="
        showModal();
        $emit('click');
      "
    >
      <template #icon>
        <FileTextOutlined v-if="item.form_id == null" />
        <FileDoneOutlined v-else />
      </template>

      {{ item.form_id == null ? "Vincular formulario" : "Desvincular formulario" }}
    </a-button>
  </a-tooltip>

  <a-modal
    v-model:visible="visible"
    title="Vincular formulario"
    width="550px"
    @cancel="handleCloseModal"
  >
    <div>
      <div>
        Selecciona un formulario para vincularlo al “{{ TypificationNameByType[item.type] }}
        {{ item.name }}”. Recuerda que solo puedes agregar un formulario por grupo.
      </div>
      <br />
      <a-form ref="form" class="form" :model="formState" :rules="rules" layout="vertical">
        <a-form-item label="Formulario que se desea vincular" name="form_id">
          <a-select
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            v-model:value="formState.form_id"
            placeholder="Seleccionar formulario"
          >
            <a-select-option v-for="form in forms" :key="form.id">
              {{ form.name }}
              <span class="select-info" v-if="[1, 2].includes(form.id)">
                (Asociado al contacto)
              </span>
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </div>
    <template #footer>
      <a-button @click="handleCancel">Cancelar</a-button>

      <a-button type="primary" :disabled="formState.form_id == null" @click="handleOk">
        Vincular
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import { defineComponent, reactive, ref, createVNode, toRaw, computed, inject } from "vue";
import { FileTextOutlined, FileDoneOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
import { Modal } from "ant-design-vue";

import { FormsTypes } from "@/app/workspace/utils/enums";
import { TypificationNameByType } from "@/app/shared/utils/enums";

const typeLabel = {
  1: "por contacto",
  2: "por producto",
};

export default defineComponent({
  components: {
    FileTextOutlined,
    FileDoneOutlined,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const currentStrategy = inject("currentStrategy");

    const visible = ref(false);
    const isDisabled = ref(props.disabled);
    const form = ref();
    const formState = reactive({
      form_id: props.item.form_id,
    });

    // This is because the association type is in the campaign edit/create modal (Just for business type 4).
    // const hasAssociationType = computed(() => [3, 4].includes(formState.form_id));
    const hasAssociationType = computed(() => false);
    const rules = computed(() => ({
      form_id: [{ required: true, message: "Campo requerido" }],
      pdp_type: [{ required: hasAssociationType.value, message: "Campo requerido" }],
    }));
    return {
      FormsTypes,
      currentStrategy,
      visible,
      isDisabled,
      form,
      formState,
      hasAssociationType,
      rules,
      TypificationNameByType,
    };
  },
  computed: {
    forms() {
      return this.$store.getters["getForms"];
    },
    isLinkFormButtonDisabled() {
      return this.isDisabled || this.item.status === 2;
    },
  },
  methods: {
    showModal() {
      if (this.item.form_id != null) {
        const pdpType = this.hasAssociationType
          ? ` ${typeLabel[this.currentStrategy.pdp_type]}`
          : "";

        Modal.confirm({
          title: `¿Estás seguro de desvincular el formulario “${this.getFormName(
            this.item.form_id
          )}${pdpType}”?`,
          content:
            "Recuerda que los usuarios ya no visualizarán ni llenarán este formulario al seleccionar la tipificación.",
          icon: createVNode(QuestionCircleOutlined),
          onOk: () => this.removeForm(),
          centered: true,
          okText: "Quitar",
          cancelText: "Cancelar",
        });
      } else {
        this.visible = true;
      }
    },
    async removeForm() {
      await this.$store.dispatch("removeForm", {
        type: this.item.type,
        id: this.item.id,
      });
      this.$message.success(`Se ha desvinculado el formulario correctamente"`);
      this.$emit("updateTree");
    },
    handleOk() {
      this.form.validateFields().then(() => {
        const values = toRaw(this.formState);
        const data = {
          id: this.item.id,
          type: this.item.type,
          ...values,
          group: this.item.group,
          result: this.item.type == "result" ? this.item.id : this.item.result,
        };
        if (this.item.type == "motive") {
          data.motive = this.item.id;
        }
        if (this.item.type == "submotive") {
          data.motive = this.item.motive;
          data.submotive = this.item.id;
        }
        this.$emit("onChange", data);
        this.visible = false;
        this.form.resetFields();
      });
    },
    getFormName(item) {
      return this.forms.find((f) => f.id == item)?.name;
    },
    handleCancel() {
      this.visible = false;
    },
  },
});
</script>

<style lang="sass" scoped>
.button-disabled
  opacity: 0.4

.container__text
  font-size: 12px
  margin-bottom: 3px
  width: 200px

.remove-icon
  color: $red-4

.select-info
  color: $gray-7
  font-size: 12px
  font-style: italic
</style>

<style>
.form-tooltip .ant-tooltip-inner {
  text-align: center !important;
}
</style>
